module.exports = __webpack_public_path__ + "img/icon_pickup.aab9c0bc.svg";